import { ANSARIT_LEGAL } from './ansarit-legal-documents'

export const LEGAL_LINKS = {
    terms: ANSARIT_LEGAL.termsOfUse.url,
    privacy: ANSARIT_LEGAL.privacyPolicy.url,
    personalData: ANSARIT_LEGAL.consentPersonalData.url,
} as const

export { ANSARIT_LEGAL } from './ansarit-legal-documents'
